/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type {
  EnterpriseArticleFragment,
  EnterpriseArticleQuery,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import EnterpriseArticlePage from 'bundles/ent-website/articles/pages/EnterpriseArticlePage';
import BlockLayout from 'bundles/ent-website/contentful/core/BlockLayout';
import { entWebsiteBlockArticleQuery } from 'bundles/ent-website/queries/EntWebsiteArticle';
import withBlockQuery from 'bundles/ent-website/utils/withBlockQuery';
import type { BlockModuleInnerProps } from 'bundles/ent-website/utils/withBlockQuery';

type Props = BlockModuleInnerProps<EnterpriseArticleFragment>;

export function EnterpriseArticle({ content, assembly = {} }: Props) {
  const renderContent = React.useCallback(
    () => <EnterpriseArticlePage pageData={content} slug={content?.slug} />,
    [content]
  );

  return <BlockLayout assembly={assembly} renderContent={renderContent} />;
}

export const BlockEnterpriseArticle = withBlockQuery<EnterpriseArticleFragment, EnterpriseArticleQuery>(
  entWebsiteBlockArticleQuery
)(EnterpriseArticle);
